<template>
  <div>
    <v-layout justify-center>
      <v-flex xs12 sm10 md8 lg6 xl4>
        <v-card flat outlined flat class="" @click="toggleAnswer">
            What is <span class="title blue--text">{{entry.label}}</span>? <span class="grey--text caption" v-if="!showAnswer">(Tap/Click)</span>
            <div v-if="showAnswer" class="blue--text title">{{entry.string}}</div>
            <div v-if="showAnswer" class="grey--text">
              {{description}}
            </div>
            <div v-if="!annotation">
              <img width="85%" :src='image'>
            </div>


            <div v-if="annotation">
              <img v-if="!showAnswer" width="85%" :src='image'>
              <v-layout row wrap v-if="showAnswer">
                <v-flex xs8>
                  <img :src='image'>
                </v-flex>
                <v-flex xs8>
                  <img :src='annotation'>
                </v-flex>
              </v-layout>

            </div>
        </v-card>
      </v-flex>

    </v-layout>
  </div>


</template>

<script>
export default {
  name: 'cardQuestionAnswer',
  props: ['card'],
  data() {
    return {
      cardId: null,
      showAnswer: false,
      image: null,
      description: null,
      entry: null,
      annotation: null,


    }
  },
  watch: {
    card: function() {
      this.showAnswer = false

      this.cardId = this.card.cardId
      this.image = this.card.image
      this.description = this.card.description
      this.entry = this.card.entry
      if ('annotation' in this.card) {
        this.annotation = this.card.annotation
      }
    }
  },
  mounted() {
    this.cardId = this.card.cardId
    this.image = this.card.image
    this.description = this.card.description
    this.entry = this.card.entry
    if ('annotation' in this.card) {
      this.annotation = this.card.annotation
    }



    this.$nextTick(function () {
        window.addEventListener('keyup', event => {
          if (this.$store.state.enableHotkeys) {
            if (event.key == '1' && this.showAnswer == true) {
              this.$emit('hotkey', 1)
            }
            else if (event.key == '2' && this.showAnswer == true) {
              this.$emit('hotkey', 2)
            }
            else if (event.key == '3' && this.showAnswer == true) {
              this.$emit('hotkey', 3)
            }
            else if (event.key == 'z' && this.showAnswer == true) {
              this.$emit('hotkey', 'z')
            }
            else if (event.key == ' ') {
              this.toggleAnswer()
              this.$emit('hotkey', 'space')
            }
          }

        })
    });

  },
  methods: {
    toggleAnswer() {
      this.showAnswer = !this.showAnswer
      this.$emit('answerState', this.showAnswer)
    },

  }

}
</script scoped>

<style>
img {
  max-width:100%;
  height: auto;
}

</style>
